(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-post"] && !Shopify.designMode) return;
  try {
    (function () {
    var configEl = document.querySelector('.newsletter-post');
    if (!configEl) {
      console.log('[newsletter-post] No config element found');
      return;
    }

    var formSelector = configEl.getAttribute('data-form-selector') || '#newsletter-form';
    var endpointUrl = configEl.getAttribute('data-endpoint-url') || '';

    var form = document.querySelector(formSelector);
    if (!form) {
      console.log('[newsletter-post] No form found for selector:', formSelector);
      return;
    }
    if (!endpointUrl) {
      console.log('[newsletter-post] No endpoint URL configured');
      return;
    }

    console.log('[newsletter-post] Initialized for form:', formSelector);

    function showHaloPopup() {
      var popup = document.getElementById('halo-newsletter-message-popup'),
        message = popup.getElementsByClassName('newsletter-message')[0],
        messageText =
          'Thanks for subscribing. This newsletter is intended for trade professionals only. Access to pricing and online ordering requires an approved trade account. To register follow these steps...';
      messageIcon =
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-success" viewBox="0 0 13 13"><path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" stroke="white" stroke-width="0.7"/><path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"/><path d="M4.10645 6.7688L6.13766 8.62553" stroke="white"></svg>';

      message.innerHTML =
        '<div class="alertBox alertBox--success">\
                        ' +
        messageIcon +
        '\
                        <span class="text alertBox-message">' +
        messageText +
        '</span>\
                    </div>';

      document.body.classList.add('newsletter-message-show');

      setCookie('emailSubcribeModal', 'closed', 1);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = form.querySelector('input[name="contact[email]"]');

      if (!emailInput) {
        console.log('[newsletter-hmac] Email input not found');
        return;
      }

      var email = emailInput.value;
      var turnstileToken = form.querySelector('[name="cf-turnstile-response"]').value;

      fetch(endpointUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: 'no-cors',
        body: JSON.stringify({
          email: email,
          turnstileToken: turnstileToken, 
        }),
      }).then(() => {
        form.reset();
        showHaloPopup();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
